import { render, staticRenderFns } from "./mytask.vue?vue&type=template&id=267f4e00&scoped=true&"
import script from "./mytask.vue?vue&type=script&lang=js&"
export * from "./mytask.vue?vue&type=script&lang=js&"
import style0 from "./mytask.vue?vue&type=style&index=0&id=267f4e00&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f4e00",
  null
  
)

export default component.exports